import { Button } from "@shopify/polaris";

export function ExchangeSubmit({ disabled, onClick }) {
  return (
    <Button primary onClick={onClick} disabled={disabled}>
      Continuar
    </Button>
  );
}
